/**
 * RedRock Monitoring Admin BFF
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { SearchFacilitiesUserResponse } from './search-facilities-user-response';


export interface SearchFacilitiesResponse { 
    id: string;
    name: string;
    powerCapacity: number;
    powerReserve: number;
    equipmentQuantity: number;
    equipmentUnderRepairQuantity: number;
    freePlacesQuantity: number;
    isArchived: boolean;
    manager: SearchFacilitiesUserResponse;
    deputyManager: SearchFacilitiesUserResponse;
    technicians?: Array<SearchFacilitiesUserResponse> | null;
}

